import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('vision_benefits_set', '/vision_benefits_sets', 'benefits_set')
const actions = generator.generate()

export default actions
